// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.notification-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
}

.notifications-content {
  padding-bottom: calc(80px + env(safe-area-inset-bottom));
}

.page-header {
  padding: 24px 0;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 24px;
}
.page-header .header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.page-header .header-content .title-section {
  flex: 1;
}
.page-header .header-content .title-section .page-title {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 4px 0;
}
.page-header .header-content .title-section .subtitle {
  font-size: 14px;
  color: #64748b;
  font-weight: 400;
}
.page-header .header-content .header-actions .notification-count {
  background: #3b82f6;
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.custom-back-button {
  --color: #475569;
  --icon-font-size: 24px;
  margin-right: 8px;
}

.date-group {
  margin-bottom: 32px;
}
.date-group .date-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.date-group .date-header .date-label {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding-right: 12px;
  background: #f8fafc;
}
.date-group .date-header .date-line {
  flex: 1;
  height: 1px;
  background: #e2e8f0;
}

.notification-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.notification-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
  position: relative;
}
.notification-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: #cbd5e1;
}
.notification-card.unread {
  background: #f0f9ff;
  border-color: #bae6fd;
}
.notification-card .notification-icon {
  flex-shrink: 0;
}
.notification-card .notification-icon .icon-container {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notification-card .notification-icon .icon-container.flight-icon {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
}
.notification-card .notification-icon .icon-container.active-icon {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
}
.notification-card .notification-icon .icon-container.completed-icon {
  background: linear-gradient(135deg, #6366f1, #4f46e5);
  color: white;
}
.notification-card .notification-icon .icon-container.default-icon {
  background: #f1f5f9;
  color: #475569;
}
.notification-card .notification-icon .icon-container ion-icon {
  font-size: 20px;
}
.notification-card .notification-details {
  flex: 1;
}
.notification-card .notification-details.mobile-view {
  display: none;
}
.notification-card .notification-details.desktop-view {
  display: flex;
  flex-direction: row;
}
.notification-card .notification-details .notification-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}
.notification-card .notification-details .notification-header .notification-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}
.notification-card .notification-details .notification-header .notification-time,
.notification-card .notification-details .notification-header .notification-date {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}
.notification-card .notification-details .notification-desktop {
  width: 100%;
  padding-inline: 10px;
}
.notification-card .notification-details .notify-card {
  margin-bottom: 12px;
}
.notification-card .notification-details .notify-card .notification-header {
  margin-bottom: 0;
}
.notification-card .notification-details .notification-content {
  font-size: 14px;
  color: #475569;
  line-height: 1.5;
  margin: 0;
}
.notification-card .notification-details .notification-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.notification-card .notification-details .notification-meta .flight-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.notification-card .notification-details .notification-meta .flight-info .flight-route {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
}
.notification-card .notification-details .notification-meta .flight-info .flight-separator {
  color: #cbd5e1;
}
.notification-card .notification-details .notification-meta .flight-info .flight-id {
  font-size: 13px;
  color: #64748b;
}
.notification-card .notification-details .notification-meta .flight-info .flight-aircraft {
  font-size: 13px;
  color: #64748b;
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 4px;
}
.notification-card .notification-details .notification-meta .trip-status {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  align-self: flex-start;
}
.notification-card .notification-details .notification-meta .trip-status.status-active {
  background: #dbeafe;
  color: #1d4ed8;
}
.notification-card .notification-details .notification-meta .trip-status.status-completed {
  background: #f3e8ff;
  color: #7c3aed;
}
.notification-card .notification-details .notification-meta .trip-status.status-upcoming {
  background: #fef3c7;
  color: #d97706;
}
.notification-card .notification-details .notification-meta .trip-status.status-default {
  background: #f1f5f9;
  color: #475569;
}
.notification-card .notification-indicator {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 8px;
  height: 8px;
  background: #3b82f6;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.empty-state {
  text-align: center;
  padding: 80px 20px;
}
.empty-state .empty-icon {
  width: 80px;
  height: 80px;
  background: #f1f5f9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
}
.empty-state .empty-icon ion-icon {
  font-size: 40px;
  color: #94a3b8;
}
.empty-state .empty-title {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
}
.empty-state .empty-message {
  font-size: 15px;
  color: #64748b;
  max-width: 400px;
  margin: 0 auto;
  line-height: 1.6;
}

@keyframes pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
/* Mobile Styles */
@media (max-width: 768px) {
  ion-toolbar {
    height: 65px;
    padding-top: 10px !important;
    min-height: 0px !important;
  }
  .notification-container {
    padding: 0 12px;
  }
  .page-header {
    padding: 20px 0;
  }
  .page-header .header-content {
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
  }
  .page-header .header-content .title-section .page-title {
    font-size: 24px;
  }
  .notification-card {
    padding: 16px;
    flex-direction: column;
    gap: 12px;
  }
  .notification-card .notification-icon {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .notification-card .notification-icon .icon-container {
    width: 36px;
    height: 36px;
    margin: 0;
  }
  .notification-card .notification-icon .icon-container ion-icon {
    font-size: 16px;
  }
  .notification-card .notification-details.mobile-view {
    display: block;
    width: 100%;
  }
  .notification-card .notification-details.desktop-view {
    display: none;
  }
  .notification-card .notification-details .icon-and-title, .notification-card .notification-details .notify-card {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }
  .notification-card .notification-details .icon-and-title .notification-header, .notification-card .notification-details .notify-card .notification-header {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 0;
  }
  .notification-card .notification-details .icon-and-title .notification-header .notification-title, .notification-card .notification-details .notify-card .notification-header .notification-title {
    font-size: 16px;
    margin: 0 0 2px 0;
  }
  .notification-card .notification-details .icon-and-title .notification-header .notification-date, .notification-card .notification-details .notify-card .notification-header .notification-date {
    font-size: 13px;
    color: #64748b;
  }
  .notification-card .notification-details .notification-header {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 0;
  }
  .notification-card .notification-details .notification-header .notification-title {
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
    margin: 0;
  }
  .notification-card .notification-details .notification-header .notification-time,
  .notification-card .notification-details .notification-header .notification-date {
    font-size: 13px;
    color: #64748b;
    font-weight: 500;
  }
  .notification-card .notification-details .notification-content {
    margin: 0;
    font-size: 14px;
    color: #475569;
    line-height: 1.5;
  }
  .notification-card .notification-details .notification-meta .flight-info {
    flex-direction: row;
    align-items: flex-start;
    gap: 4px;
    margin-bottom: 8px;
    justify-content: space-between;
  }
  .notification-card .notification-details .notification-meta .flight-info .flight-separator {
    display: none;
  }
  .notification-card .notification-details .notification-meta .trip-status {
    align-self: flex-start;
  }
  .notification-card .notification-details .notification-desktop {
    display: flex;
    flex-direction: row;
  }
  .notification-card .notification-indicator {
    top: 16px;
    right: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/charter/features/charter-notifications/charter-notifications.page.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,wDAAA;AACF;;AAEA;EACE,eAAA;EACA,gCAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AACJ;AACI;EACE,OAAA;AACN;AACM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AACR;AAEM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAAR;AAKM;EACE,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAHR;;AASA;EACE,gBAAA;EACA,sBAAA;EACA,iBAAA;AANF;;AASA;EACE,mBAAA;AANF;AAQE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AANJ;AAQI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;AANN;AASI;EACE,OAAA;EACA,WAAA;EACA,mBAAA;AAPN;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AATF;;AAYA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AATF;AAWE;EACE,0CAAA;EACA,qBAAA;AATJ;AAYE;EACE,mBAAA;EACA,qBAAA;AAVJ;AAaE;EACE,cAAA;AAXJ;AAaI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAXN;AAaM;EACE,qDAAA;EACA,YAAA;AAXR;AAcM;EACE,qDAAA;EACA,YAAA;AAZR;AAeM;EACE,qDAAA;EACA,YAAA;AAbR;AAgBM;EACE,mBAAA;EACA,cAAA;AAdR;AAiBM;EACE,eAAA;AAfR;AAoBE;EACE,OAAA;AAlBJ;AAoBI;EACE,aAAA;AAlBN;AAqBI;EACE,aAAA;EACA,mBAAA;AAnBN;AAsBI;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;AApBN;AAsBM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AApBR;AAuBM;;EAEE,eAAA;EACA,cAAA;EACA,gBAAA;AArBR;AAyBI;EACE,WAAA;EACA,oBAAA;AAvBN;AA0BI;EACE,mBAAA;AAxBN;AA0BM;EACE,gBAAA;AAxBR;AA4BI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AA1BN;AA6BI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA3BN;AA6BM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AA3BR;AA6BQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA3BV;AA8BQ;EACE,cAAA;AA5BV;AA+BQ;EACE,eAAA;EACA,cAAA;AA7BV;AAgCQ;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AA9BV;AAkCM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AAhCR;AAkCQ;EACE,mBAAA;EACA,cAAA;AAhCV;AAmCQ;EACE,mBAAA;EACA,cAAA;AAjCV;AAoCQ;EACE,mBAAA;EACA,cAAA;AAlCV;AAqCQ;EACE,mBAAA;EACA,cAAA;AAnCV;AAyCE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;AAvCJ;;AA2CA;EACE,kBAAA;EACA,kBAAA;AAxCF;AA0CE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAxCJ;AA0CI;EACE,eAAA;EACA,cAAA;AAxCN;AA4CE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AA1CJ;AA6CE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA3CJ;;AA+CA;EACE;IACE,UAAA;IACA,mBAAA;EA5CF;EA8CA;IACE,YAAA;IACA,qBAAA;EA5CF;EA8CA;IACE,UAAA;IACA,mBAAA;EA5CF;AACF;AA+CA,kBAAA;AACA;EACE;IACE,YAAA;IACA,4BAAA;IACA,0BAAA;EA7CF;EA+CA;IACE,eAAA;EA7CF;EAgDA;IACE,eAAA;EA9CF;EAgDE;IACE,mBAAA;IACA,uBAAA;IACA,SAAA;EA9CJ;EAiDM;IACE,eAAA;EA/CR;EAqDA;IACE,aAAA;IACA,sBAAA;IACA,SAAA;EAnDF;EAqDE;IACE,aAAA;IACA,mBAAA;IACA,SAAA;EAnDJ;EAqDI;IACE,WAAA;IACA,YAAA;IACA,SAAA;EAnDN;EAqDM;IACE,eAAA;EAnDR;EAyDI;IACE,cAAA;IACA,WAAA;EAvDN;EA0DI;IACE,aAAA;EAxDN;EA2DI;IACE,aAAA;IACA,mBAAA;IACA,SAAA;IACA,mBAAA;EAzDN;EA2DM;IACE,OAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,SAAA;EAzDR;EA2DQ;IACE,eAAA;IACA,iBAAA;EAzDV;EA4DQ;IACE,eAAA;IACA,cAAA;EA1DV;EA+DI;IACE,OAAA;IACA,aAAA;IACA,8BAAA;IACA,uBAAA;IACA,SAAA;EA7DN;EA+DM;IACE,eAAA;IACA,gBAAA;IACA,cAAA;IACA,SAAA;EA7DR;EAgEM;;IAEE,eAAA;IACA,cAAA;IACA,gBAAA;EA9DR;EAkEI;IACE,SAAA;IACA,eAAA;IACA,cAAA;IACA,gBAAA;EAhEN;EAoEM;IACE,mBAAA;IACA,uBAAA;IACA,QAAA;IACA,kBAAA;IACA,8BAAA;EAlER;EAoEQ;IACE,aAAA;EAlEV;EAsEM;IACE,sBAAA;EApER;EAwEI;IACE,aAAA;IACA,mBAAA;EAtEN;EA0EE;IACE,SAAA;IACA,WAAA;EAxEJ;AACF","sourcesContent":[":host {\n  display: block;\n  height: 100%;\n}\n\n.notification-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 16px;\n}\n\n.notifications-content {\n  padding-bottom: calc(80px + env(safe-area-inset-bottom))\n}\n\n.page-header {\n  padding: 24px 0;\n  border-bottom: 1px solid #e2e8f0;\n  margin-bottom: 24px;\n\n  .header-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n\n    .title-section {\n      flex: 1;\n      \n      .page-title {\n        font-size: 28px;\n        font-weight: 700;\n        color: #1e293b;\n        margin: 0 0 4px 0;\n      }\n      \n      .subtitle {\n        font-size: 14px;\n        color: #64748b;\n        font-weight: 400;\n      }\n    }\n\n    .header-actions {\n      .notification-count {\n        background: #3b82f6;\n        color: white;\n        padding: 6px 12px;\n        border-radius: 20px;\n        font-size: 12px;\n        font-weight: 600;\n        white-space: nowrap;\n      }\n    }\n  }\n}\n\n.custom-back-button {\n  --color: #475569;\n  --icon-font-size: 24px;\n  margin-right: 8px;\n}\n\n.date-group {\n  margin-bottom: 32px;\n\n  .date-header {\n    display: flex;\n    align-items: center;\n    margin-bottom: 16px;\n    \n    .date-label {\n      font-size: 14px;\n      font-weight: 600;\n      color: #64748b;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n      padding-right: 12px;\n      background: #f8fafc;\n    }\n    \n    .date-line {\n      flex: 1;\n      height: 1px;\n      background: #e2e8f0;\n    }\n  }\n}\n\n.notification-items {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.notification-card {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  border: 1px solid #e2e8f0;\n  transition: all 0.2s ease;\n  position: relative;\n  \n  &:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    border-color: #cbd5e1;\n  }\n  \n  &.unread {\n    background: #f0f9ff;\n    border-color: #bae6fd;\n  }\n  \n  .notification-icon {\n    flex-shrink: 0;\n    \n    .icon-container {\n      width: 44px;\n      height: 44px;\n      border-radius: 10px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      \n      &.flight-icon {\n        background: linear-gradient(135deg, #3b82f6, #1d4ed8);\n        color: white;\n      }\n      \n      &.active-icon {\n        background: linear-gradient(135deg, #10b981, #059669);\n        color: white;\n      }\n      \n      &.completed-icon {\n        background: linear-gradient(135deg, #6366f1, #4f46e5);\n        color: white;\n      }\n      \n      &.default-icon {\n        background: #f1f5f9;\n        color: #475569;\n      }\n      \n      ion-icon {\n        font-size: 20px;\n      }\n    }\n  }\n  \n  .notification-details {\n    flex: 1;\n    \n    &.mobile-view {\n      display: none;\n    }\n    \n    &.desktop-view {\n      display: flex;\n      flex-direction: row;\n    }\n    \n    .notification-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n      margin-bottom: 8px;\n      \n      .notification-title {\n        font-size: 16px;\n        font-weight: 600;\n        color: #1e293b;\n        margin: 0;\n      }\n      \n      .notification-time,\n      .notification-date {\n        font-size: 13px;\n        color: #64748b;\n        font-weight: 500;\n      }\n    }\n\n    .notification-desktop {\n      width: 100%;\n      padding-inline: 10px;\n    }\n    \n    .notify-card {\n      margin-bottom: 12px;\n      \n      .notification-header {\n        margin-bottom: 0;\n      }\n    }\n    \n    .notification-content {\n      font-size: 14px;\n      color: #475569;\n      line-height: 1.5;\n      margin: 0;\n    }\n    \n    .notification-meta {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n      \n      .flight-info {\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n        gap: 8px;\n        \n        .flight-route {\n          font-size: 13px;\n          font-weight: 600;\n          color: #334155;\n        }\n        \n        .flight-separator {\n          color: #cbd5e1;\n        }\n        \n        .flight-id {\n          font-size: 13px;\n          color: #64748b;\n        }\n        \n        .flight-aircraft {\n          font-size: 13px;\n          color: #64748b;\n          background: #f1f5f9;\n          padding: 2px 8px;\n          border-radius: 4px;\n        }\n      }\n      \n      .trip-status {\n        font-size: 12px;\n        font-weight: 600;\n        padding: 4px 10px;\n        border-radius: 12px;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        align-self: flex-start;\n        \n        &.status-active {\n          background: #dbeafe;\n          color: #1d4ed8;\n        }\n        \n        &.status-completed {\n          background: #f3e8ff;\n          color: #7c3aed;\n        }\n        \n        &.status-upcoming {\n          background: #fef3c7;\n          color: #d97706;\n        }\n        \n        &.status-default {\n          background: #f1f5f9;\n          color: #475569;\n        }\n      }\n    }\n  }\n  \n  .notification-indicator {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    width: 8px;\n    height: 8px;\n    background: #3b82f6;\n    border-radius: 50%;\n    animation: pulse 2s infinite;\n  }\n}\n\n.empty-state {\n  text-align: center;\n  padding: 80px 20px;\n  \n  .empty-icon {\n    width: 80px;\n    height: 80px;\n    background: #f1f5f9;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 24px;\n    \n    ion-icon {\n      font-size: 40px;\n      color: #94a3b8;\n    }\n  }\n  \n  .empty-title {\n    font-size: 20px;\n    font-weight: 600;\n    color: #1e293b;\n    margin: 0 0 8px 0;\n  }\n  \n  .empty-message {\n    font-size: 15px;\n    color: #64748b;\n    max-width: 400px;\n    margin: 0 auto;\n    line-height: 1.6;\n  }\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.5;\n    transform: scale(0.8);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Mobile Styles */\n@media (max-width: 768px) {\n  ion-toolbar {\n    height: 65px;\n    padding-top: 10px !important;\n    min-height: 0px !important;\n  }\n  .notification-container {\n    padding: 0 12px;\n  }\n  \n  .page-header {\n    padding: 20px 0;\n    \n    .header-content {\n      flex-direction: row;\n      align-items: flex-start;\n      gap: 12px;\n      \n      .title-section {\n        .page-title {\n          font-size: 24px;\n        }\n      }\n    }\n  }\n  \n  .notification-card {\n    padding: 16px;\n    flex-direction: column;\n    gap: 12px;\n    \n    .notification-icon {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      \n      .icon-container {\n        width: 36px;\n        height: 36px;\n        margin: 0;\n        \n        ion-icon {\n          font-size: 16px;\n        }\n      }\n    }\n    \n    .notification-details {\n      &.mobile-view {\n        display: block;\n        width: 100%;\n      }\n      \n      &.desktop-view {\n        display: none;\n      }\n      \n      .icon-and-title, .notify-card {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        margin-bottom: 12px;\n        \n        .notification-header {\n          flex: 1;\n          display: flex;\n          flex-direction: column;\n          align-items: flex-start;\n          margin: 0;\n          \n          .notification-title {\n            font-size: 16px;\n            margin: 0 0 2px 0;\n          }\n          \n          .notification-date {\n            font-size: 13px;\n            color: #64748b;\n          }\n        }\n      }\n      \n      .notification-header {\n        flex: 1;\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-start;\n        margin: 0;\n        \n        .notification-title {\n          font-size: 16px;\n          font-weight: 600;\n          color: #1e293b;\n          margin: 0;\n        }\n        \n        .notification-time,\n        .notification-date {\n          font-size: 13px;\n          color: #64748b;\n          font-weight: 500;\n        }\n      }\n      \n      .notification-content {\n        margin: 0;\n        font-size: 14px;\n        color: #475569;\n        line-height: 1.5;\n      }\n      \n      .notification-meta {\n        .flight-info {\n          flex-direction: row;\n          align-items: flex-start;\n          gap: 4px;\n          margin-bottom: 8px;\n          justify-content: space-between;\n          \n          .flight-separator {\n            display: none;\n          }\n        }\n        \n        .trip-status {\n          align-self: flex-start;\n        }\n      }\n\n      .notification-desktop {\n        display: flex;\n        flex-direction: row;\n      }\n    }\n    \n    .notification-indicator {\n      top: 16px;\n      right: 16px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
